import { useTranslation } from 'react-i18next';

import { z } from 'zod';

import { AdvertisingPackageResponse, SpaceResponse } from '@/api/data-contracts';

import {
  PackageBookingSchema,
  SpaceBookingSchema,
  calculateCampaignDuration,
  makeMediaPlanFormSchema,
  mapFormPackageBookingsToRequest,
  mapFormSpaceBookingsToRequest,
  mapPackageToPackageBooking,
  mapPlanPackageBookingsToRequest,
  mapPlanSpaceBookingsToRequest,
  mapSpaceToSpaceBooking,
} from '../model';

export const useMediaPlanForm = (): any => {
  const { t } = useTranslation();

  const FormSchema = makeMediaPlanFormSchema(t);

  return {
    SpaceBookingSchema,
    PackageBookingSchema,
    FormSchema,
    mapPlanSpaceBookingsToRequest,
    mapPlanPackageBookingsToRequest,
    mapFormSpaceBookingsToRequest,
    mapFormPackageBookingsToRequest,
    mapSpaceToSpaceBooking,
    mapPackageToPackageBooking,
    calculateCampaignDuration,
  };
};

export type SpaceBookingType = z.infer<
  ReturnType<typeof useMediaPlanForm>['SpaceBookingSchema']
> & { space: SpaceResponse; packageBooking?: PackageBookingType };
export type PackageBookingType = z.infer<
  ReturnType<typeof useMediaPlanForm>['PackageBookingSchema']
> & { advertisingPackage: AdvertisingPackageResponse };
